module.exports = __webpack_public_path__ + "static/media/sonic-globe.8230dcbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sonic-globe.png
// module id = 924
// module chunks = 0